import { useState } from 'react'
import { useToastState } from 'transfix-ui/components/Toast/Toast'
import {
  CreateBookableShipmentSavedSearchRequestBody,
  useCreateBookableShipmentSavedSearch,
  useDeleteBookableShipmentSavedSearch,
} from '../types'

export const useTruckAvailabilityToggle = () => {
  const { mutate: createSavedShipment } = useCreateBookableShipmentSavedSearch({})
  const { mutate: deleteSavedSearch } = useDeleteBookableShipmentSavedSearch({})
  const { closeToast, openToast, toastMessage, toastOpen, toastType } = useToastState()
  const [createdSavedSearchId, setCreatedSavedSearchId] = useState<undefined | number>(undefined)
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const createTruckAvailability = async (
    savedSearch: CreateBookableShipmentSavedSearchRequestBody
  ) => {
    setIsLoading(true)
    setCreatedSavedSearchId(undefined)
    try {
      const { bookableShipmentSavedSearch } = await createSavedShipment(savedSearch)
      const { id } = bookableShipmentSavedSearch || {}
      if (id) {
        setCreatedSavedSearchId(id)
        openToast({
          toastType: 'default',
          toastMessage: "You'll receive emails about loads matching this truck.",
        })
      }
    } catch (e) {
      openToast({
        toastType: 'alert',
        toastMessage: 'Something went wrong. Please contact us.',
      })
    }
    setIsLoading(false)
  }

  const deleteTruckAvailability = async () => {
    setIsLoading(true)
    try {
      if (createdSavedSearchId) {
        await deleteSavedSearch(createdSavedSearchId)
        openToast({
          toastType: 'default',
          toastMessage: "You'll no longer receive emails about loads matching this truck.",
        })
      }
    } catch (e) {
      openToast({
        toastType: 'alert',
        toastMessage: 'Something went wrong. Please contact us.',
      })
    }
    setCreatedSavedSearchId(undefined)
    setIsLoading(false)
  }

  return {
    createdSavedSearchId,
    isLoading,
    toastType,
    toastOpen,
    closeToast,
    toastMessage,
    createTruckAvailability,
    deleteTruckAvailability,
  }
}
